<template>
  <main
    class="article page-main"
  >
    <section class="article-detail">
      <div class="article-detail-heading">
        <div class="article-detail-meta">
          <span class="article-detail-category" @click.prevent="goCategory">{{ $t('menuNewsroom.release') }}</span>
          <time class="article-detail-date" :datetime="$moment(desserts.reportDistributeDay).format('YY.MM.DD')">{{ $moment(desserts.reportDistributeDay).format('YY.MM.DD') }}</time>
        </div>
        <div class="article-detail-title">
          <strong><html-view :value="desserts.reportTitle | highlight($route.query.word)" /></strong>
          <small v-if="desserts.reportSubTitle"><html-view :value="desserts.reportSubTitle | highlight($route.query.word)" /></small>
        </div>
      </div>

      <loading v-if="loading" />

      <div v-else class="article-detail-content">
        <div v-if="desserts.summaries && desserts.summaries.length > 0" class="article-detail-summary">
          <ul v-for="item in desserts.summaries" :key="item.reportSummarySeq">
            <li>{{ item.reportSummaryContents }}</li>
          </ul>
        </div>

        <html-view :value="desserts.content | highlight($route.query.word)" class="editor" />
      </div>

      <div class="share-wrap">
        <share
          :seq="Number($route.params.newsroomId)"
          :title="desserts.reportTitle"
          :type="'REPORT'"
          :share-image="desserts.reportImagePath"
        />
      </div>
    </section>

    <section v-if="desserts.previous || desserts.next" class="relate">
      <p class="relate-title">{{ $t('detail.wantNext') }}</p>
      <div class="relate-content">
        <div class="list list-default">
          <div v-if="desserts.previous" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, newsroomId : desserts.previous.reportSeq}}">
              <div v-if="desserts.previous.reportImagePath" class="list-thumb"><img :src="desserts.previous.reportImagePath" alt="" @error.once="onImageError"></div>
              <div class="list-cont">
                <p class="list-title">{{ desserts.previous.reportTitle }}</p>
                <p v-if="desserts.previous.reportSubTitle && desserts.previous.reportSubTitle.trim().length > 0" class="list-desc">{{ desserts.previous.reportSubTitle }}</p>
                <div>
                  <time class="list-date">{{ $moment(desserts.previous.reportDistributeDay).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
          <div v-if="desserts.next" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, newsroomId : desserts.next.reportSeq}}">
              <div v-if="desserts.next.reportImagePath" class="list-thumb"><img :src="desserts.next.reportImagePath" alt="" @error.once="onImageError"></div>
              <div class="list-cont">
                <p class="list-title">{{ desserts.next.reportTitle }}</p>
                <p v-if="desserts.next.reportSubTitle && desserts.next.reportSubTitle.trim().length > 0" class="list-desc">{{ desserts.next.reportSubTitle }}</p>
                <div>
                  <time class="list-date">{{ $moment(desserts.next.reportDistributeDay).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <button type="button" class="btn" @click.prevent="goList">{{ $t('seeList') }}</button>
      </div>
    </section>
  </main>
</template>
<script>
import newsroomApi from '@/api/newsroom'
import contentDetail from '@/mixins/contentDetail'

export default {
  components: {
    share: () => import('@/components/base/Share'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [contentDetail],
  data () {
    return {
      desserts: {},
      defaultImgPath: require('@/static/image/default.jpg'),
      loading: false
    }
  },
  watch: {
    '$route.params.newsroomId' () {
      this.getDetail()
    },
    '$route.params.locale' () {
      this.getDetail()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.$route.query.sharekey) {
      this.getShareDetail()
    } else {
      this.getDetail()
    }
  },
  methods: {
    async getDetail () {
      this.loading = true
      const { data } = await newsroomApi.getReportDetail(this.$route.params.newsroomId, {
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.loading = false
        this.setContents()
      }
    },
    async getShareDetail () {
      this.loading = true
      const { data } = await newsroomApi.getReportLink({
        linkKey: this.$route.query.sharekey,
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.$nextTick(this.setSlider)
        this.loading = false
        this.setContents()
      }
    },
    goList () {
      if (this.$route.query.word) {
        this.$router.push({ name: 'NewsroomSearch', query: { ...this.$route.query } })
      } else {
        this.goCategory()
      }
    },
    goCategory () {
      this.$router.push({
        name: 'NewsroomReport',
        params: this.$route.params,
        query: { page: 1 }
      })
    },
    onImageError (e) {
      e.target.src = this.defaultImgPath
    }
  }
}
</script>
